import { HttpClientXsrfModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {
    FoehnAddressModule,
    FoehnBooleanModule,
    FoehnCheckablesModule,
    FoehnFormModule,
    FoehnIconsModule,
    FoehnInputModule,
    FoehnInputNav13Module,
    FoehnMenuPrestationModule,
    FoehnModalModule,
    FoehnMultiUploadModule,
    FoehnNavigationModule,
    FoehnNotFoundModule,
    FoehnPageModule,
    FoehnRecapSectionModule,
    FoehnRemainingAlertsSummaryModule,
    FoehnValidationAlertsModule,
    FormatterModule,
    GesdemConfirmationModule,
    GesdemErrorModule,
    PipeModule,
    PrestationsNgCoreModule,
    SdkDictionaryModule,
    SdkRecaptchaModule,
    SdkRedirectModule
} from '@dsivd/prestations-ng';
import { NgHttpLoaderModule } from 'ng-http-loader';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AccordionGroupComponent } from './components/accordion/accordion-group.component';
import { AccordionItemComponent } from './components/accordion/accordion-item.component';
import { RecapSectionModule } from './components/recap-section/recap-section.module';
import { RemainingAlertsSummaryComponent } from './components/remaining-alerts-summary/remaining-alerts-summary.component';
import { YearPeriodComponent } from './components/year-period/year-period.component';
import { PageWrapperComponent } from './page-wrapper/page-wrapper.component';
import { InformationApplicantPageComponent } from './pages/information-applicant-page/information-applicant-page.component';
import { LegalRepresentativePageComponent } from './pages/legal-representative-page/legal-representative-page.component';
import { ProfessionalProjectPageComponent } from './pages/professional-project-page/professional-project-page.component';
import { RequestOriginPageComponent } from './pages/request-origin-page/request-origin-page.component';
import { RequestProcurationPageComponent } from './pages/request-procuration-page/request-procuration-page.component';
import { RequestSummaryPageComponent } from './pages/request-summary-page/request-summary-page.component';
import { CustomPipeModule } from './pipes/custom-pipes.module';
import { META_SERVICE_PROVIDER } from './services/meta/meta.service';

@NgModule({
    declarations: [
        AppComponent,
        PageWrapperComponent,
        ProfessionalProjectPageComponent,
        RequestOriginPageComponent,
        InformationApplicantPageComponent,
        RequestProcurationPageComponent,
        RequestSummaryPageComponent,
        LegalRepresentativePageComponent,
        AccordionGroupComponent,
        AccordionItemComponent,
        YearPeriodComponent,
        RemainingAlertsSummaryComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientXsrfModule,
        AppRoutingModule,
        NgHttpLoaderModule.forRoot(),
        PrestationsNgCoreModule,
        FoehnNotFoundModule,
        GesdemErrorModule,
        GesdemConfirmationModule,
        SdkRedirectModule,
        FoehnInputModule,
        SdkRecaptchaModule,
        FoehnNavigationModule,
        FoehnFormModule,
        PipeModule,
        FoehnPageModule,
        FoehnValidationAlertsModule,
        FoehnRecapSectionModule,
        FoehnRemainingAlertsSummaryModule,
        FoehnInputNav13Module,
        FoehnAddressModule,
        FoehnBooleanModule,
        FoehnMultiUploadModule,
        FormatterModule,
        FoehnCheckablesModule,
        FoehnModalModule,
        FoehnMenuPrestationModule,
        RecapSectionModule,
        FoehnIconsModule,
        SdkDictionaryModule,
        CustomPipeModule,
    ],
    providers: [META_SERVICE_PROVIDER],
    bootstrap: [AppComponent]
})
export class AppModule {
}


